import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLaunch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_41848_7265)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M3.61532 7.68821L0.599854 6.02096C1.80159 3.71639 4.16798 3.15869 5.9938 3.66546",
				stroke: "#42296E",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.31567 10.3887L7.98292 13.4042C10.2797 12.2007 10.8394 9.8404 10.3372 8.01587",
				stroke: "#42296E",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.61548 7.6781L3.64082 7.69374C4.73328 8.36803 5.65178 9.28986 6.32212 10.3847C8.48743 9.0876 10.9489 7.83131 12.0724 6.66694C14.5033 4.23608 13.0938 0.906402 13.0938 0.906402C13.0938 0.906402 9.76414 -0.503093 7.33328 1.92777C6.16891 3.05128 4.90241 5.52301 3.61548 7.6781Z",
				stroke: "#42296E",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.73427 12.66C3.42491 12.9587 2.60673 13.2422 1.8293 13.4584C1.02902 13.6809 0.318883 12.9707 0.541366 12.1704C0.757497 11.393 1.04108 10.5748 1.33978 10.2655C1.49489 10.099 1.68193 9.96547 1.88975 9.87287C2.09757 9.78027 2.32192 9.73048 2.5494 9.72646C2.77688 9.72245 3.00285 9.7643 3.21381 9.84951C3.42477 9.93472 3.6164 10.0616 3.77728 10.2225C3.93816 10.3833 4.06499 10.575 4.1502 10.7859C4.23541 10.9969 4.27726 11.2229 4.27324 11.4503C4.26923 11.6778 4.21944 11.9022 4.12684 12.11C4.03424 12.3178 3.90073 12.5049 3.73427 12.66Z",
				stroke: "#42296E",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.8606 4.13941L10.2361 3.76392",
				stroke: "#42296E",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_41848_7265",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white"
		})
	}) })]
});
export default SvgLaunch;
